import {createStore} from 'vuex'
import cloneDeep from 'lodash-es/cloneDeep';
import modules from './modules'
import {crud} from "./generator";

const _ = require("lodash");

const crudModules = crud({
    patientTherapies: 'patient/me/therapies',
    expertPrograms: 'patient/expert-programs',
    patientTasks: 'patient/me/tasks'
})

const store = createStore({
    modules: _.merge(crudModules, modules),
    strict: process.env.NODE_ENV !== 'production',
})

window.addEventListener('health-data-changed', function () {
    store.commit('healthData/INVALIDATE', {});
});

const initialState = cloneDeep(store.state);

store.reset = function () {
    store.replaceState(initialState);
};

export default store;
